<template>
    <mu-checkbox label="复选框" />
</template>
<script>
export default {
    name: 'checkBox'
}
</script>



// WEBPACK FOOTER //
// checkBox.vue?2d3a8384